var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tfoot',[_c('tr',[_c('td',[_vm._v("Total")]),_c('td',[_vm._v(_vm._s(_vm.totals.deals))]),_c('td',[_vm._v(_vm._s(_vm.totals.pctTotalDeals))]),_c('td',[_vm._v(_vm._s(_vm.totals.investment))]),_c('td',[_vm._v(_vm._s(_vm.totals.costPerDeal))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }